module.exports = __webpack_public_path__ + "static/media/dct-final.ee59b4ac.jpg";